import { InfiosIcon } from '@infios/uikit/react';
import styles from './StatusIndicator.module.css';

interface StatusIndicatorProps {
  /** Optional engine status text (e.g. "Searching orders…"). */
  label?: string | null;
}

/**
 * The assistant "thinking" affordance shown while a turn is streaming: a small
 * agent avatar + animated dots, optionally replaced by the engine's live status
 * description (tool step, routing, etc.).
 */
export function StatusIndicator({ label }: StatusIndicatorProps) {
  return (
    <div className={styles.row} aria-live="polite">
      <span className={styles.avatar} aria-hidden>
        <InfiosIcon name="robot" />
      </span>
      <div className={styles.bubble}>
        {label ? (
          <span className={styles.label}>{label}</span>
        ) : (
          <span className={styles.dots} aria-label="Assistant is typing">
            <span className={styles.dot} />
            <span className={styles.dot} />
            <span className={styles.dot} />
          </span>
        )}
      </div>
    </div>
  );
}
